import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions, selectors } from '@/Store';
import { AppId, SignOutDeviceType } from '@skytvnz/sky-app-store/lib/types/graph-ql';

const useDeviceSessions = () => {
  const dispatch = useDispatch();
  const deviceSessionsData = useSelector(selectors.devices.deviceSessions);
  const deviceSessionsIsLoading = useSelector(selectors.devices.deviceSessionsIsLoading);
  const deviceSessionsError = useSelector(selectors.devices.deviceSessionsError);

  useEffect(() => {
    const fetchDeviceSessions = () => {
      dispatch(actions.devices.fetchDeviceSessions(AppId.SkyGoWeb));
    };
    fetchDeviceSessions();
  }, [dispatch]);

  const signOutFromDevice = useCallback(
    async (appId: AppId, deviceTypes: SignOutDeviceType[]): Promise<void> => {
      await dispatch(actions.devices.signOutDevice(appId, deviceTypes));
    },
    [dispatch],
  );

  return { deviceSessionsData, signOutFromDevice, deviceSessionsIsLoading, deviceSessionsError };
};

export default useDeviceSessions;
